import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    'search-selected-item': async () => import('./search-selected-item/SearchSelectedItem.vue'),
    'search-item': async () => import('./search-item/SearchItem.vue')
  }
})
class MultiSelectComponent extends Vue {

  dtSearch?: string | null;
  dtTemporaryOptions?: any;
  dtIsLoading?: boolean | null;
  private _clearTimeout: any;
  /**
   *
   */
  constructor() {
    super();
    this.dtSearch = '';
    this.dtTemporaryOptions = this.options;
    this.dtIsLoading = false;
  }

  @Prop({ default: () => [], type: [Array, Number, Object, String] })
  value: any

  @Prop({ default: 300, type: [Number] })
  debound: any

  @Prop({ type: [Function] })
  fetch: any;

  @Prop({ type: [Boolean] })
  loading: any;

  @Prop({ type: [Object, Array] })
  rules: any;

  @Prop({ default: false, type: [Boolean] })
  readonly: boolean;

  @Prop({ default: true, type: [Boolean] })
  allowDefaultSelected: boolean;
  @Prop({ default: false, type: [Boolean] })
  allowGroup: boolean;
  @Prop({ default: true, type: [Boolean] })
  allowDefaultItem: boolean;

  @Prop({ default: () => [], type: [Array] })
  options: string[] | any[];

  @Prop({ default: false, type: [Boolean] })
  returnObject: boolean;

  @Prop({ type: [String] })
  itemText: string;
  @Prop({ default: null, type: [String] })
  itemSubtext: string;
  @Prop({ type: [String], default: 'id' })
  itemValue: string;

  @Prop({ type: [String], default: null })
  icon: string;

  @Prop({ default: null, type: [String] })
  label: string | null;
  @Prop({ default: null, type: [String] })
  placeholder: string | null;
  @Prop({ default: null, type: [String] })
  noDataText: string | null;
  @Prop({ default: false, type: [Boolean] })
  required: boolean;
  @Prop({ default: true, type: [Boolean] })
  autoUpdate: boolean;
  @Prop({ default: false, type: [Boolean] })
  isUpdating: boolean;
  @Prop({ default: false, type: [Boolean] })
  disabled: boolean;
  @Prop({ default: true, type: [Boolean] })
  multiple: boolean;
  @Prop({ default: false, type: [Boolean] })
  hideDetails: boolean;
  @Prop({ default: false, type: [Boolean] })
  autoSelectFirst: boolean;

  get coRules() {
    if (this.disabled) {
      return undefined;
    }
    return this.rules;
  }
  get locale(): string {
    return this.$i18n.locale;
  }
  get coIsLoading(): boolean {
    return this.loading || this.dtIsLoading;
  }

  get vModel(): any | null {
    return this.value;
  }
  set vModel(value: any | null) {
    this.$emit('input', value);
  }
  get coOptions() {
    return this.dtTemporaryOptions.map(x => {
      if (this.allowGroup === false)
        x.text = x[this.itemText] || `${x.firstname || ''} ${x.lastname || ''}`
      return x;
    });
  }
  get coSelectedData() {
    if (this.options !== null && this.options.length > 0 && typeof this.options[0] === 'object') {
      return this.vModel.map(id => this.getPerson(id).next().value);
    }
    else return this.vModel;
  }
  *getPerson(id: number): any {
    const person: {
      firstname: string,
      type: string,
      lastname: string
    } = (this.dtTemporaryOptions as any).find(item => item[this.itemValue] === id);
    yield person || {};
  }

  @Emit('change')
  handleRemove(data: any, index: number) {
    if (Array.isArray(this.value)) {
      if (typeof data === 'object') {
        if (this.returnObject) {
          this.vModel = this.value.filter(item => item.id !== data.id);
        }
        else this.vModel = this.value.filter(item => item !== data.id);
      }
    }
    else this.vModel = null;

  }
  mounted() {
    if (this.fetch) {
      this.$watch('dtSearch', (value: string, oldValue: string) => {
        if (value && value.length > 0 && oldValue && oldValue.length > 0)
          this.handleFilter(value);
      })
    } else {
      this.$watch('dtSearch', this.handleFilterLocally)
    }
  }

  handleFilter(query: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtIsLoading = true;
      this.fetch(query)
        .then(response => {
          this.dtTemporaryOptions = ([...response || [], ...this.options || []]).map(x => {
            if (x.header === null || x.header === undefined || x.divider) {
              x.firstname = x.firstname || x[this.itemText] || '';
              x.lastname = x.lastname || x[this.itemSubtext] || '';
              x.text = `${x.firstname} ${x.lastname}`
            }
            return x;
          })
        })
        .catch(error => console.log(error))
        .finally(() => this.dtIsLoading = false);
    }, this.debound);
  }

  @Emit('change')
  handleChange(event) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (event && !Array.isArray(event)) {
        (this.$refs['seletorRef'] as any).blur()
      }
    }, 10);
  }

  handleClearData() { }

  handleFilterLocally(newValue: any, oldValue: any) {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtTemporaryOptions = (this.options as any).filter(item => this.createFilter(item, newValue)).slice(0);
    }, 300)
  }

  createFilter(item: any, key: string) {

    const keywordCooked: string = (key || '').toLowerCase();
    return (item.firstname || '').toLowerCase().indexOf(keywordCooked) > -1
      || (item.lastname || '').toLowerCase().indexOf(keywordCooked) > -1
      || (item[this.itemText] || '').toLowerCase().indexOf(keywordCooked) > -1
      || (item[this.itemSubtext] || '').toLowerCase().indexOf(keywordCooked) > -1
      || (item.text || '').toLowerCase().indexOf(keywordCooked) > -1;
  }

  @Watch('options')
  handleChangeOptions(val) {
    this.dtTemporaryOptions = val;
  }
}

export default MultiSelectComponent;



// WEBPACK FOOTER //
// ./src/components/multi-select/index.ts